import * as Sentry from '@sentry/browser';
import * as SentryIntegrations from '@sentry/integrations';
import Env from '../environment';

let SentryInitialized = false;
const InitSentry = () => {
  if (SentryInitialized) {
    return;
  }

  if (!process.env.REACT_APP_SENTRY_DSN) {
    console.warn('process.env.REACT_APP_SENTRY_DSN is not set.');
  }

  if (!process.env.REACT_APP_SENTRY_RELEASE) {
    console.warn('process.env.REACT_APP_SENTRY_RELEASE is not set.');
  }

  const sentryOptions = {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    environment: Env.getName(),
    debug: true
  };

  // When we're developing locally
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.REACT_APP_LOCALHOST_SENTRY !== 'true'
  ) {
    // Don't actually send the errors to Sentry
    // sentryOptions.beforeSend = () => null;
    // sentryOptions.ignoreErrors = [];

    // Instead, dump the errors to the console
    sentryOptions.integrations = [
      new SentryIntegrations.Debug({
        // Trigger DevTools debugger instead of using console.log
        debugger: false
      })
    ];
  }

  Sentry.init(sentryOptions);
  SentryInitialized = true;
};

const replaceErrors = (key, value) => {
  try {
    // Check only error object
    if (value && typeof value === 'object' && value.message) {
      const error = {};

      Object.getOwnPropertyNames(value).forEach((propKey) => {
        error[propKey] = value[propKey];
      });

      return error;
    }
    return value;
  } catch (e) {
    return value;
  }
};

const captureException = (error) => {
  let targetError = error;

  if (!targetError) {
    return null;
  }

  // If string then convert it to Error obj
  if (typeof targetError === 'string') {
    targetError = new Error(targetError);
  } else if (
    // Convert object to Error object if its not
    typeof targetError === 'object' &&
    targetError.message &&
    !targetError.stack
  ) {
    const tmpError = new Error(targetError.message);
    targetError = Object.assign(tmpError, targetError);
  }

  Sentry.configureScope((scope) => {
    if (targetError.message) {
      // De-duplication currently doesn't work correctly for SSR / browser errors
      // so we force de duplication by error message if it is present
      scope.setFingerprint([targetError.message]);
    }

    if (targetError.statusCode || targetError.code) {
      const code = targetError.statusCode || targetError.code;
      scope.setExtra('statusCode', code);
    }

    scope.setExtra('ErrorObj', JSON.stringify(targetError, replaceErrors, 2));
  });

  return Sentry.captureException(targetError);
};

export { InitSentry };
export { Sentry };
export { captureException };
